import { Injectable } from "@angular/core";
import {
  CanActivate,
  CanLoad,
  Router,
  Route,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from "@angular/router";
import { AuthService } from 'dlv-ng-auth';
import { environment } from './../../../environments/environment';
import { SettingsConstant } from "./../../shared/constants/settings.constants";
import { LocalStorageService } from "./../../shared/services/local-storage.service";
import { CommonService } from "./../../shared/services/common.service";
import { ApiUrlConstant } from "./../../shared/constants/api-url.constant";
import { JwtHelper } from "angular2-jwt";
import { NgxPermissionsService } from "ngx-permissions";
import { LoaderService } from "./loader.service";
import { LoginService } from "./login.service"

@Injectable({
  providedIn: "root"
})
export class AuthGuardService implements CanActivate {
  constructor(
    private router: Router,
    private auth: AuthService,
    private localStorage: LocalStorageService,
    private commonService: CommonService,
    private apiUrl: ApiUrlConstant,
    private permissionService: NgxPermissionsService,
    private loader: LoaderService,
    private loginService: LoginService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return this.checkLogin(state.url);
  }

  private checkLogin(url: string): boolean {
    // 666 Code with no use
    // if(this.auth0.isAuthenticated()){
    //   this.auth0.logOut();
    // }
    if (!this.auth.isAuthenticated()) {
      this.loginService.logOut();
      // 666 ends
      
      return false;
    } else {
      const scopes = this.localStorage.getItem(`${SettingsConstant.LOCALSTORAGE_KEYS.USER_SCOPES}`);
      if (scopes && scopes.length) {
        return true
      } else {
        this.loader.start();
        this.commonService.getSelfScopes().subscribe((res) => {
          this.loader.stop();
          const permissions = res['permissions'];
          let scopePermissions = permissions.filter(permission => permission['app_id'] == Number(environment.UMS_APP_ID));
          if (scopePermissions.length) {
            scopePermissions = scopePermissions.map(permission => permission['scope']);
            let token = this.commonService.getCookie(`${environment.accessToken}`)
            let jwtHelper = new JwtHelper();
            let userDetails = jwtHelper.decodeToken(token)
            this.localStorage.setItem(`${SettingsConstant.LOCALSTORAGE_KEYS.USER_SCOPES}`, scopePermissions);

            this.permissionService.loadPermissions(scopePermissions);

            this.localStorage.setItem(`${SettingsConstant.LOCALSTORAGE_KEYS.USER_DETAILS}`, userDetails);

            const clientDetails = this.localStorage.getItem(
              SettingsConstant.LOCALSTORAGE_KEYS.CLIENT_LIST
            );
            this.loader.stop();
            if(clientDetails.length) {
              this.navigateTo("/overall-status");
              return true;
            } else {
              return this.getClientList();
            }

          } else {
            this.navigateTo("/forbidden");
            return false;
          }

        }, (err) => {
          this.loader.stop();
          this.navigateTo("/forbidden");
          return false;
        });


      }
    }
  }

  getClientList() {
    this.loader.start();
    this.commonService.getUserClientMapping().subscribe((response) => {
      this.loader.stop();
      if (response["data"] && response["data"].length) {
        this.localStorage.setItem(`${SettingsConstant.LOCALSTORAGE_KEYS.CLIENT_LIST}`,
          JSON.stringify(response["data"]));
        if (response["data"].length > 1) {
          /**if there is only one client associated with the logged in user then we will store it on localstorage
                otherwise we will redirect it to select client page
          **/
          const preSelectedClient = this.localStorage.getItem(
            `${SettingsConstant.LOCALSTORAGE_KEYS.SELECTED_CLIENT}`);
          if (!preSelectedClient) {
            this.localStorage.setItem(
              `${SettingsConstant.LOCALSTORAGE_KEYS.SELECTED_CLIENT}`,
              response["data"][0]["client_uuid"]
            );
          }
        } else {
          this.localStorage.setItem(
            `${SettingsConstant.LOCALSTORAGE_KEYS.SELECTED_CLIENT}`,
            response["data"][0]["client_uuid"]
          );
        }
        this.navigateTo("/overall-status");
        return true;
      } else {
        this.router.navigate(['/forbidden'], { queryParams: { message: 'ERROR: 404CLIENT, You dont have any client associated with your account. please contact administrator for adding client in your account.' } });
        return false;
      }
    }, error => {
      this.loader.stop();
      this.router.navigate(['/forbidden'], { queryParams: { message: 'ERROR: 404CLIENT, You dont have any client associated with your account. please contact administrator for adding client in your account.' } });
      return false;
    });
  }

  private navigateTo(route: string) {
    this.router.navigate([`/${route}`], { replaceUrl: true });
  }
}
